export const readFileUrl = async (url: string, type: string = 'image/jpg'): Promise<File> => {
  const response = await fetch(url);
  const data = await response.blob();
  const metadata = {
    type: 'image/jpg',
  };

  return new File([data], url.split('/').pop(), metadata);
};
